import jQuery from 'jquery';

export function getRawSvg(url, callback) {
  jQuery.ajax({
    method: 'GET',
    url: url,
  }).fail(console.error.bind(console, 'getRawSvg'))
    .then((svg)=> {
      const svgElement = svg.getElementsByTagName('svg')[0];
      svgElement.removeAttribute('width');
      svgElement.removeAttribute('height');
      svgElement.removeAttribute('xmlns:a');
      callback(svgElement.outerHTML);
    });
}
